export default __webpack_public_path__ + "static/media/test1.05481260.jpg";